import React from 'react';
export * from './social';
// Basic icons
export const ICON_ADD = <i className="material-icons">add</i>;
export const ICON_MORE = <i className="material-icons">more_vert</i>;
export const ICON_COMMENT = <i className="material-icons">comment</i>;
export const ICON_ERROR = <i className="material-icons">error</i>;
export const ICON_REMOVE = <i className="material-icons">remove</i>;
export const ICON_EDIT = <i className="material-icons">edit</i>;
export const ICON_DELETE = <i className="material-icons">delete</i>;
export const ICON_SAVE = <i className="material-icons">save</i>;
export const ICON_CLOSE = <i className="material-icons">close</i>;
export const ICON_CHECK = <i className="material-icons">check</i>;
export const ICON_CANCEL = <i className="material-icons">cancel</i>;
export const ICON_CLEAR = <i className="material-icons">clear</i>;
export const ICON_SEARCH = <i className="material-icons">search</i>;
export const ICON_COPY = <i className="material-icons">content_copy</i>;
export const ICON_SHARE = <i className="material-icons">share</i>;
export const ICON_HOME = <i className="material-icons">home</i>;
export const ICON_USER = <i className="material-icons">person</i>;
export const ICON_GROUP = <i className="material-icons">group</i>;
export const ICON_CHART = <i className="material-icons">bar_chart</i>;
export const ICON_DRAG = <i className="material-icons">drag_indicator</i>;
export const ICON_DRAG_HANDLE = <i className="material-icons">drag_handle</i>;
export const ICON_UNDO = <i className="material-icons">undo</i>;
export const ICON_ZOOM_IN = <i className="material-icons">zoom_in</i>;
export const ICON_ZOOM_OUT = <i className="material-icons">zoom_out</i>;



// Arrows
export const ICON_UP = <i className="material-icons">keyboard_arrow_up</i>;
export const ICON_DOWN = <i className="material-icons">keyboard_arrow_down</i>;
export const ICON_LEFT = <i className="material-icons">keyboard_arrow_left</i>;
export const ICON_RIGHT = <i className="material-icons">keyboard_arrow_right</i>;
export const ICON_BACK = <i className="material-icons">arrow_back</i>;

// LAYOUT
export const ICON_ROW = <i className="material-icons">view_column</i>;
export const ICON_COLUMN = <i className="material-icons">view_stream</i>;
